
 /* good-address controller
  -----------------------
  Disables the "good_address" checkbox unless at least one
  address-related field has content.

  Safe against missing fields.
*/
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["address", "city", "state", "zipcode", "checkbox", "hint"]

  connect() {
    this.refresh()
  }

  refresh() {
    const hasAddr =
      this.present("address") ||
      this.present("city") ||
      this.present("state") ||
      this.present("zipcode")

    if (this.hasCheckboxTarget) {
      this.checkboxTarget.disabled = !hasAddr
      if (!hasAddr) this.checkboxTarget.checked = false
    }

    if (this.hasHintTarget) {
      this.hintTarget.classList.toggle("d-none", hasAddr)
    }
  }

  present(name) {
    const el = this.getTarget(name)
    if (!el) return false
    return (el.value || "").trim().length > 0
  }

  getTarget(name) {
    const has = this[`has${this.capitalize(name)}Target`]
    return has ? this[`${name}Target`] : null
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
}
